import React from 'react';
import PropTypes from 'prop-types';

/**
 * Título de modal al estilo mockup: eyebrow + título.
 * Uso: <ModalHeading eyebrow="Registrar" title="Usuario" />
 */
const ModalHeading = ({ eyebrow, title, children }) => (
  <div className="modal-heading">
    {eyebrow ? <span className="modal-heading__eyebrow">{eyebrow}</span> : null}
    <span className="modal-heading__title">{title || children}</span>
  </div>
);

ModalHeading.defaultProps = {
  eyebrow: '',
  title: '',
  children: null
};

ModalHeading.propTypes = {
  eyebrow: PropTypes.node,
  title: PropTypes.node,
  children: PropTypes.node
};

export default ModalHeading;
